"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NestedLocale = void 0;
var string_format_1 = require("../string-format/string-format");
var NestedLocale = /** @class */function () {
  function NestedLocale(resources) {
    this.resources = resources;
  }
  NestedLocale.prototype.translate = function (key, stringFormatData) {
    var _a = this.resources,
      _b = key,
      value = _a[_b];
    if (typeof value === 'string') {
      var stringFormat = new string_format_1.StringFormat();
      return stringFormat.format(value, stringFormatData);
    }
    return JSON.stringify(value);
  };
  return NestedLocale;
}();
exports.NestedLocale = NestedLocale;